<div
  class="flex"
  *ngIf="{ connectedAccounts: connectedAccounts$ | async, hasWriteAccess: hasWriteAccess$ | async } as vm">
  <sbnb-subnav header="Settings">
    <sbnb-devices-subnav></sbnb-devices-subnav>
  </sbnb-subnav>

  <main class="flex-1 subnav__exists page-device-setup" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <sbnb-content-header
      title="Settings"
      [saveButtonShown]="false"
      [sticky]="false"
      novaContentId="smart-devices-settings"></sbnb-content-header>

    <mat-tab-group class="settings-tabs">
      <mat-tab label="Smart Locks">
        <div class="tab-body">
          <div *ngIf="vm.connectedAccounts.error" class="error">{{ vm.connectedAccounts.error }}</div>

          <div *ngIf="vm.connectedAccounts.data?.length === 0" class="error">
            <sbnb-no-items text="No connected accounts found"></sbnb-no-items>
          </div>

          <span class="text__small smoke-darker" *ngIf="vm.connectedAccounts.data?.length !== 0">
            Changes made here also affect any RemoteLock devices.
          </span>
          <app-settings-smartlocks
            [canEditSettings]="vm.hasWriteAccess"
            *ngIf="vm.connectedAccounts.data?.length !== 0"></app-settings-smartlocks>
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex items-center gap-0">
            Thermostats
            <span class="badge text-[8px] scale-75">New</span>
          </div>
        </ng-template>

        <div class="tab-body">
          <ng-container>
            <app-settings-thermostats
              [canEditSettings]="vm.hasWriteAccess"
              *ngIf="vm.connectedAccounts.data?.length !== 0"></app-settings-thermostats>
          </ng-container>

          <ng-template #notEnabled>
            <div class="flex items-center justify-center p-8">
              <a
                href="https://hospitable.com/pricing/"
                target="_blank"
                rel="noopener noreferrer"
                class="text-center link-muted">
                To connect an Ecobee or Honeywell thermostat go to 'Connect devices'. See pricing here.
              </a>
            </div>
          </ng-template>
        </div>
      </mat-tab>
    </mat-tab-group>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Devices">
  <sbnb-devices-subnav></sbnb-devices-subnav>
</sbnb-mobile-sidebar>
